module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Titel i tabben":"For business","Ett urval av rekryteringar som genomförts med Gritify:":"A selection of matches made with Gritify:","asd":"asd"},"sv":{"Titel i tabben":"För företag","Ett urval av rekryteringar som genomförts med Gritify:":"Ett urval av matchningar som gjorts med Gritify:","asd":"asd"}}')
  delete Component.options._Ctor
}
